import type { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import AppHeader from './AppHeader';
import NavMenu from './NavMenu';
import { getDashboardStats } from '../../services/api';

interface AppLayoutProps {
  children: ReactNode;
}

const defaultTaxYear = new Date().getFullYear() - 1;

export default function AppLayout({ children }: AppLayoutProps) {
  const { data: stats } = useQuery({
    queryKey: ['dashboardStats', defaultTaxYear],
    queryFn: () => getDashboardStats(defaultTaxYear),
    refetchInterval: 60 * 1000,
    staleTime: 30 * 1000,
  });

  return (
    <div className="app-container">
      <AppHeader />
      <div className="app-body">
        <NavMenu unassignedDropoffs={stats?.unassignedDropoffs ?? 0} />
        <main className="app-content">
          {children}
        </main>
      </div>
    </div>
  );
}
